import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'
import { Grid } from 'components/grid'
import AvatarBase from 'components/avatar'
import Paragraph from 'components/typography/paragraph'
import { CheckCircleFilled } from 'components/feather'

export const Wrap = styled(Grid)`
    grid-auto-flow: column;
    grid-template-columns: 40px minmax(0, 1fr);
    column-gap: 16px;
    justify-content: start;
    align-items: center;

    &:not(:last-of-type) {
        margin-block-end: 16px;
    }

    &.signed {
        grid-template-columns: 40px minmax(0, 1fr) 20px;
    }
`

export const Avatar = styled(AvatarBase)`
    height: auto;
`

export const Name = styled(Paragraph)`
    line-height: 20px;
`

export const Success = styled(CheckCircleFilled)`
    ${svgStroke()}

    align-self: center;

    color: var(--huma-color-foreground-success);
`